import React from 'react';
import PropTypes from 'prop-types';
import ContactForm from './contact/ContactForm';
import AcademyConfigProp from './propTypes/academyConfig';

export default function ContactAndAboutUs({ academyConfig }) {
  return (
    <div className="landing-contact-container">
      <div className="landing-contact-overall">
        <div className="row" style={{ width: '100%' }}>
          <div className="col-lg-5 col-md-6">
            <ContactForm />
          </div>
          <div className="col-lg-7 col-md-6">
            {academyConfig?.aboutUs && (
              <div className="landing-engagement-text">
                <h3 className="landing-engagement-title">
                  {academyConfig.aboutUs.title}
                </h3>
                <hr className="divider-white" />
                <div className="landing-engagement-items">
                  <div className="landing-engagement-item">
                    <p className="landing-engagement-description">
                      {academyConfig.aboutUs.description}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

ContactAndAboutUs.propTypes = {
  academyConfig: PropTypes.shape(AcademyConfigProp.propType).isRequired,
};
